import axios from 'axios';

const prefix = a => 'Panel/IssuedLetter' + (a ? `/${a}` : '');

export default {
  index(params, config = {}) {
    const url = prefix();
    return params === true ? url : axios.get(url, {...config, params});
  },
  store(data = {}, config = {}) {
    const url = prefix();
    return data === true ? url : axios.post(url, data, config);
  },
  update(id, data = {}, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.put(url, data, config);
  },
  show(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.get(url, config);
  },
  destroy(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.delete(url, config);
  },
  // Clients for the letter pickers. Scoped server-side: a regular user only
  // gets the clients he is linked to, the administration gets all of them.
  // Passing `true` returns the url, for the select components that fetch it.
  clients(params = {}, config = {}) {
    const url = prefix('clients');
    return params === true ? url : axios.get(url, {...config, params});
  },
  // Preview (no save): resolve template + merged fields for a claim.
  prefill(carClaimId, letterTemplateId = null, issuedFor = null, discountPercent = null, userNote = null, config = {}) {
    const url = prefix('prefill');
    return axios.get(url, {
      ...config,
      params: {
        car_claim_id: carClaimId,
        letter_template_id: letterTemplateId,
        issued_for: issuedFor,
        discount_percent: discountPercent,
        user_note: userNote
      }
    });
  },
  // The letter as HTML, for reading it on screen. Works while it is still
  // pending, which is the whole point: pending letters have no file yet.
  preview(id, config = {}) {
    return axios.get(prefix(`${id}/preview`), config);
  },
  // A Word letter rendered to PDF for reading on screen. Side-effect free:
  // it never stores the file, so a pending letter stays unrendered.
  previewFile(id, config = {}) {
    return axios.get(prefix(`${id}/previewFile`), {...config, responseType: 'blob'});
  },
  // Download the stored PDF as a blob (auth-checked).
  // NOTE: the server deletes the letter once it has sent the file, so this can
  // only ever succeed once per letter.
  download(id, config = {}) {
    const url = prefix(`${id}/download`);
    return axios.get(url, {...config, responseType: 'blob'});
  },
  // Admin: approve (تعميد) a pending letter so its PDF gets rendered.
  approve(id, config = {}) {
    return axios.post(prefix(`${id}/approve`), {}, config);
  },
  // Admin: refuse a letter. User: withdraw his own pending approval request.
  cancel(id, config = {}) {
    return axios.post(prefix(`${id}/cancel`), {}, config);
  }
};
